import React from 'react';
import '../styles/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <p>© 2025 Antalya Oto Çekici Kurtarıcı | Tüm Hakları Saklıdır</p>
            <div className="social-links">
                <a href="tel:+905514978161" className="call-btn"><i className="fas fa-phone-alt"></i> Bizi
                    Arayın</a>
                <a href="https://wa.me/905514978161" className="call-btn"><i
                    className="fab fa-whatsapp"></i> WhatsApp</a>
            </div>
        </footer>
    );
}

export default Footer;
